import { Injectable } from '@angular/core';

export enum EnvironmentUrl {
  DEV = 'jsapps.c5vp9gk-shimanoin1-d1-public.model-t.cc.commerce.ondemand.com',
  STG = 'jsapps.c5vp9gk-shimanoin1-s1-public.model-t.cc.commerce.ondemand.com',
  PROD = 'b2b.shimano.com',
}

export enum GoogleTagManagerParams {
  GTM_ID = 'GTM-NZ5QS4J',
  GTM_AUTH_DEV = 'gNeZ-DiFLrrRXuxmerQ95A',
  GTM_AUTH_STG = 'h_OUtfTChnSgEnUjJcTYaw',
  GTM_PREVIEW_DEV = 'env-34',
  GTM_PREVIEW_STG = 'env-37',
  GTM_COOKIES_WIN = 'x',
}

export enum GoogleTagManagerEvent {
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  PRODUCT_IMPRESSION = 'view_item',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',
  PRODUCT_CLICK = 'select_content',
  PRODUCT_DETAILS = 'select_item',
  PROMO_VIEW = 'view_promotion',
  SEARCH = 'search',
  CLICK_FACET = 'click_facet',
  SELECT_PROMOTION = 'select_promotion',
}

export enum GoogleTagManagerProductListName {
  PLP = 'Product Listing Page',
  PDP = 'Product Details Page',
  SEARCH_PAGE = 'Search Page',
  SEARCH_BOX = 'Search Box',
  ORDER_FORM_PAGE = 'Order Form Page',
  QUICK_ORDER_PAGE = 'Quick Order Page',
  ALTERNATIVE_PRODUCTS = 'Alternative Products',
  CART_PAGE = 'Cart Page',
}

export const GoogleTagManagerPrefix = 'gtm_';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private isLoaded = false;

  private browserGlobals = {
    windowRef(): any {
      return window;
    },
    documentRef(): any {
      return document;
    },
  };

  constructor() {}

  public getDataLayer() {
    const window = this.browserGlobals.windowRef();
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  private pushOnDataLayer(obj: object) {
    const dataLayer = this.getDataLayer();
    dataLayer.push(obj);
  }

  public addGtmToDom() {
    const doc = this.browserGlobals.documentRef();
    this.pushOnDataLayer({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const gtmScript = doc.createElement('script');
    gtmScript.text =
      `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl` +
      this.appendGtmQueryParamsByEnvironment(document.location.hostname, false) +
      `;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','` +
      GoogleTagManagerParams.GTM_ID +
      `')`;
    doc.head.insertBefore(gtmScript, doc.head.firstChild);

    const ifrm = doc.createElement('iframe');
    ifrm.setAttribute(
      'src',
      'https://www.googletagmanager.com/ns.html?id=' +
        GoogleTagManagerParams.GTM_ID +
        this.appendGtmQueryParamsByEnvironment(document.location.hostname, true)
    );
    ifrm.style.width = '0';
    ifrm.style.height = '0';
    ifrm.style.display = 'none';
    ifrm.style.visibility = 'hidden';

    const noscript = doc.createElement('noscript');
    noscript.appendChild(ifrm);

    doc.body.insertBefore(noscript, doc.body.firstChild);
    this.isLoaded = true;
  }

  public pushTag(item: object) {
    if (!this.isLoaded) {
      this.addGtmToDom();
    }
    this.pushOnDataLayer(item);
  }

  private appendGtmQueryParamsByEnvironment(hostname: string, iFrameBody = false): string {
    const params: string[] = [];
    // tslint:disable-next-line: quotemark
    let initString = iFrameBody ? '&' : "+'&";
    switch (hostname) {
      case EnvironmentUrl.DEV:
        params.push(`gtm_auth=${GoogleTagManagerParams.GTM_AUTH_DEV}`);
        params.push(`gtm_preview=${GoogleTagManagerParams.GTM_PREVIEW_DEV}`);
        params.push(`gtm_cookies_win=${GoogleTagManagerParams.GTM_COOKIES_WIN}`);
        break;
      case EnvironmentUrl.STG:
        params.push(`gtm_auth=${GoogleTagManagerParams.GTM_AUTH_STG}`);
        params.push(`gtm_preview=${GoogleTagManagerParams.GTM_PREVIEW_STG}`);
        params.push(`gtm_cookies_win=${GoogleTagManagerParams.GTM_COOKIES_WIN}`);
        break;
      default:
        initString = '';
        break;
    }
    let appendString = initString + params.join('&');
    // tslint:disable-next-line: quotemark
    return (appendString += iFrameBody ? '' : params.length ? "'" : '');
  }

  public clearGtmSessionStorage() {
    Object.entries(sessionStorage)
      .map((x) => x[0])
      .filter((x) => x.substring(0, GoogleTagManagerPrefix.length) === GoogleTagManagerPrefix)
      .map((x) => sessionStorage.removeItem(x));
  }
}
